export const SET_NO_DATA_TITLE = 'SET_NO_DATA_TITLE';
export const SET_NO_DATA_TITLE_CONFIG = "SET_NO_DATA_TITLE_CONFIG"

/**
 * Sets noDataTitle configuration.
 */
export const setNoDataTitle = (data) => ({
  type: 'SET_NO_DATA_TITLE',
  payload: data,
});

export const setNoDataTitleConfiguration = (data) => ({
  type: "SET_NO_DATA_TITLE_CONFIG",
  payload: data
})
